export const toO365InputCreateRequest = ({
  clientId,
  clientSecret,
  contents,
  o365Name,
  o365DropSensitiveDlpLogs,
  o365StoreFullMessage,
  o365ThrottleEnabled,
  pollingInterval,
  timeoutGracePeriodMinutes,
  subscriptionType,
  tenantId
}) => {
  var _a;
  return {
    name: o365Name.value,
    content_types: contents.value.split(","),
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES",
    o365_tenant_id: tenantId.value,
    enable_throttling: !!(o365ThrottleEnabled == null ? void 0 : o365ThrottleEnabled.value),
    store_full_message: !!(o365StoreFullMessage == null ? void 0 : o365StoreFullMessage.value),
    drop_sensitive_info_logs: !!(o365DropSensitiveDlpLogs == null ? void 0 : o365DropSensitiveDlpLogs.value),
    o365_client_id: clientId.value,
    o365_client_secret: clientSecret.value,
    endpoint_type: subscriptionType.value,
    timeout_grace_period_minutes: Number((_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : 5)
  };
};
export const toGenericInputCreateRequest = ({
  clientId,
  clientSecret,
  contents,
  o365Name,
  o365StoreFullMessage,
  o365DropSensitiveDlpLogs,
  o365ThrottleEnabled,
  pollingInterval,
  timeoutGracePeriodMinutes,
  subscriptionType,
  tenantId
}) => {
  var _a;
  return {
    type: "org.graylog.enterprise.integrations.office365.Office365Input",
    title: o365Name.value,
    global: false,
    configuration: {
      content_types: contents.value.split(","),
      polling_interval: pollingInterval.value,
      polling_time_unit: "MINUTES",
      tenant_id: tenantId.value,
      throttling_allowed: !!(o365ThrottleEnabled == null ? void 0 : o365ThrottleEnabled.value),
      drop_sensitive_dlp_logs: !!(o365DropSensitiveDlpLogs == null ? void 0 : o365DropSensitiveDlpLogs.value),
      store_full_message: !!(o365StoreFullMessage == null ? void 0 : o365StoreFullMessage.value),
      client_id: clientId.value,
      client_secret: clientSecret.value,
      subscription_type: subscriptionType.value,
      timeout_grace_period_minutes: Number((_a = timeoutGracePeriodMinutes == null ? void 0 : timeoutGracePeriodMinutes.value) != null ? _a : 5)
    }
  };
};
